export default __webpack_public_path__ + "static/media/new-q2link-blue.8b82cbb5.svg";